import { render } from "./privacyView.vue?vue&type=template&id=1232f1e5"
import script from "./privacyView.vue?vue&type=script&lang=js"
export * from "./privacyView.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__